import { render, staticRenderFns } from "./ChangeMedia.vue?vue&type=template&id=c021e156&scoped=true"
import script from "./ChangeMedia.vue?vue&type=script&lang=ts"
export * from "./ChangeMedia.vue?vue&type=script&lang=ts"
import style0 from "./ChangeMedia.vue?vue&type=style&index=0&id=c021e156&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c021e156",
  null
  
)

export default component.exports